import React from "react";
import { Link, withRouter } from "react-router-dom";
import useDomainStore from "../../stores/domain";
import styles from "./MerchantNameLink.module.scss";

function MerchantNameLink({ history, children, powerappId, className = "" }) {
  const { isKurvDomain } = useDomainStore();
  if (!powerappId) {
    return <>{children}</>;
  }
  const base = history.location.pathname.startsWith("/v2/")
    ? "/v2/merchants"
    : "/merchants";
  return (
    <Link
      to={`${base}?id=${encodeURIComponent(String(powerappId))}`}
      className={`${styles.link} ${isKurvDomain ? styles.link_kurv : ""} ${className}`.trim()}
      onClick={(e) => e.stopPropagation()}
    >
      {children}
    </Link>
  );
}

export default withRouter(MerchantNameLink);
